import Service from "../../services";

const FormRF = {
  namespaced: true,
  state: {
    formResearch: 1,
    researchID: "",
    countApproveRF: "",
    countVerifyRF: "",
  },
  mutations: {
    SET_PAGE: (state, page) => {
      state.formResearch = page;
    },
    SET_RESEARCH_ID: (state, res) => {
      state.researchID = res.researchID;
    },
    SET_COUNT_APPROVE_RF: (state, rf) => {
      state.countApproveRF = rf;
    },
    SET_COUNT_VERIFY_RF: (state, rf) => {
      state.countVerifyRF = rf;
    },
    createState: (state) => {
      state.formResearch = 1;
      state.researchID = "";
      state.countApproveRF = "";
      state.countVerifyRF = "";
    },
  },
  actions: {
    saveRF04_1({ commit }, data) {
      return Service.formRF
        .saveRF04_1(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRF04_1({ commit }, data) {
      return Service.formRF
        .saveEditRF04_1(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveRF04_2({ commit }, data) {
      return Service.formRF
        .saveRF04_2(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRF04_2({ commit }, data) {
      return Service.formRF
        .saveEditRF04_2(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveRF06({ commit }, data) {
      return Service.formRF
        .saveRF06(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRF06({ commit }, data) {
      return Service.formRF
        .saveEditRF06(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveRF12({ commit }, data) {
      return Service.formRF
        .saveRF12(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRF12({ commit }, data) {
      return Service.formRF
        .saveEditRF12(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveRF03({ commit }, data) {
      return Service.formRF
        .saveRF03(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRF03({ commit }, data) {
      return Service.formRF
        .saveEditRF03(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveRF05({ commit }, data) {
      return Service.formRF
        .saveRF05(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRF05({ commit }, data) {
      return Service.formRF
        .saveEditRF05(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveRF07({ commit }, data) {
      return Service.formRF
        .saveRF07(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRF07({ commit }, data) {
      return Service.formRF
        .saveEditRF07(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveEditRFSusar({ commit }, data) {
      console.log('store',data);
      return Service.formRF
        .saveEditRFSusar(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRFSusar({commit},id) {
      return Service.formRF.getRFSusar(id).then(res => {
          return res;
      }).catch(err => {
          return Promise.reject(err)
      })
  },
    getRF12({ commit }, id) {
      return Service.formRF
        .getRF12(id)
        .then((res) => {
          // commit("SET_RESEARCH_ID", res);
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getCorres({ commit }, id) {
      return Service.formRF
        .getCorres(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRF05({ commit }, id) {
      return Service.formRF
        .getRF05(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getDeviationReportByIdResearch({ commit }, id) {
      return Service.formRF
        .getDeviationReportByIdResearch(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRF03({ commit }, id) {
      return Service.formRF
        .getRF03(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRF04_1({ commit }, id) {
      return Service.formRF
        .getRF04_1(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRF04_2({ commit }, id) {
      return Service.formRF
        .getRF04_2(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRF06({ commit }, id) {
      return Service.formRF
        .getRF06(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRF07({ commit }, id) {
      return Service.formRF
        .getRF07(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getRF({ commit }, data) {
      return Service.formRF
        .getRF(data)
        .then((res) => {
          let rf =
            res.ResearchAmendmentCount +
            res.AdverseEventCount +
            res.DeviationReportCount +
            res.ProgressReportCount +
            res.ResearchSummarizeCount +
            res.ResearchTerminationCount +
            res.AdverseDrugEventCount;
          commit("SET_COUNT_VERIFY_RF", rf);
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getDocumentResearch({ commit }, data) {
      return Service.formRF.getDocumentResearch(data).then((res) => {
        return res.data;
      }).catch((err) => {
        return Promise.reject(err);
      })
    },
    getRFAll({ commit }, data) {
      console.log(data);
      return Service.formRF
        .getRFAll(data)
        .then((res) => {
          let verifyRF =
            res.ResearchAmendmentCount +
            res.AdverseEventCount +
            res.DeviationReportCount +
            res.ProgressReportCount +
            res.ResearchSummarizeCount +
            res.ResearchTerminationCount +
            res.AdverseDrugEventCount;
          commit("SET_COUNT_APPROVE_RF", verifyRF);
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    updateStatusRF({ commit }, data) {
      return Service.formRF
        .updateStatusRF(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    updateStatusRF2({ commit }, data) {
      return Service.formRF
        .updateStatusRF2(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    checkRF({ commit }, data) {
      return Service.formRF
        .checkRF(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    deleteRF({ commit }, data) {
      return Service.formRF
        .deleteRF(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    ApproveRF({ commit }, data) {
      return Service.formRF
        .ApproveRF(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    createState({ commit }) {
      commit("createState");
    },
  },
};

export default FormRF;
